var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-session-1"},[_c('div',{staticClass:"city-rank-wrapper d-flex flex-column"},[_c('div',{staticClass:"city-rank-list-content"},[_c('rank-list',{attrs:{"listHeight":880,"tableTitle":_vm.areaTableTitleList,"list":_vm.cityRankOptions}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }